import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { Input, Button, Icon } from 'loyal-react'

import MediaQuery from 'react-responsive'

const NumericPasswordBoxStep4 = ({
  passwordNumConfirmation,
  isHidden,
  handleBack,
  isLoading,
  numericPassword,
  handleNumericPassConfirm,
  validateNumericPasswordConfirm
}) => {
  const isValid = passwordNumConfirmation.length === 6
  return (
    <>
      <div id='password-numric-box-step-4' className={`box-login row pb-4 ${isHidden && 'd-none'}`}>
        <div className='col-12 col-md-6 col-lg-4 mr-auto ml-auto py-3 px-3 radius bg-white border border-color-ui-3 pb-5 mb-5'>
          <div className='row'>
            <div className='col-6 col-md-12 mb-2'>
              <p className='txt-body-sm'>
                <MediaQuery maxWidth={489}>
                  <a
                    id='image-link'
                    href='#'
                    className='txt-body-sm pointer'
                    aria-label='Voltar'
                    role='button'
                    onClick={handleBack}
                  >
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
                <MediaQuery minWidth={490}>
                  <a
                    href='#'
                    className='txt-body-sm pointer'
                    aria-label='Voltar'
                    role='button'
                    onClick={handleBack}
                  >
                    <Icon className='icon icon_left_app' />
                  </a>
                </MediaQuery>
              </p>
            </div>
            <MediaQuery maxWidth={489}>
              <div className='col-6 mb-2 close-login'>
                <p className='txt-body-sm'>
                  <a href={`https://${process.env.RAZZLE_APP_TENANT_DOMAIN}`} className='txt-body-sm d-flex justify-content-end' aria-label='Fechar tela de login' role='button'>
                    <Icon className='icon icon_menu_app_close' />
                  </a>
                </p>
              </div>
            </MediaQuery>
          </div>
          <div className='row'>
            <div className='col-12'>
              <h1 className='h1 login-title color-brand-1 txt-font-body mb-1'>
                sua senha numérica foi salva com sucesso.
              </h1>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 txt-center mt-2'>
              <Button
                className='btn btn-sm btn-featured border border-color-ui-3 mr-1'
                type='button'
                text='entre e aproveite'
                onClick={validateNumericPasswordConfirm}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

NumericPasswordBoxStep4.propTypes = {
  passwordNumConfirmation: PropTypes.string,
  isLoading: PropTypes.bool,
  isHidden: PropTypes.bool,
  handleBack: PropTypes.func.isRequired,
  numericPassword: PropTypes.func,
  handleNumericPassConfirm: PropTypes.func,
  validateNumericPasswordConfirm: PropTypes.func
}

export default withRouter(NumericPasswordBoxStep4)
